// extracted by mini-css-extract-plugin
export default {"support":"index_support_4nUCN","supportTitle":"index_supportTitle_lXg2F","supportContent":"index_supportContent_E-35p","rights":"index_rights_ogeXj"};